import { Injectable, NgZone } from '@angular/core';
import { EnvService } from './env.service';
import { UserStore } from '../store/user.store';

@Injectable()
export class GTM {

  private tracking: boolean;
  private trackLog: boolean;

  constructor(private envService: EnvService, public userStore: UserStore, private readonly ngZone: NgZone) {
    this.tracking = this.envService.trackingEnabled();
    this.trackLog = this.envService.trackLogEnabled();
  }

  public init() { }

  public get dataLayer(): any {
    return (window as any).dataLayer;
  }

  /**
   * Génère un event_id unique (timestamp + random encodé en base64)
   */
  private generateEventId(): string {
    return btoa(Date.now() + '-' + Math.random().toString(36).substring(2, 9));
  }

  /**
   * Tracking d’une page (page_view event)
   */
  public trackPage(pageName: string, pageType: string, virtualPath: string, previous?: { name?: string, type?: string }) {
    let layerData: any = {
      event: 'page_view',
      event_id: this.generateEventId(),
      page: {
        name: pageName,
        type: pageType,
        virtual_path: virtualPath,
        previous: {
          name: previous?.name || '',
          type: previous?.type || ''
        }
      }
    };

    const userCard = this.userStore.userCard();
    if (userCard) {
      layerData.user = {
        card_type: userCard?.cardType === 2 ? "C-Casto" : userCard?.cardType === 3 ? "C-Casto Max" : "",
        home_type: userCard?.habitationType === 0 ? "Appartement" : userCard?.habitationType === 1 ? "Maison" : "",
        has_project: userCard?.projectNext6Months ? Object.values(userCard.projectNext6Months).some(v => v) ? "oui" : "non" : "non",
        id: userCard?.id ?? null,
        is_logged_in: true,
        loyalty_card_number: userCard?.cardNumber ?? null,
        project_type: userCard?.projectNext6Months ? Object.entries(userCard.projectNext6Months).filter(([_, value]) => value).map(([key]) => key) : [],
        status_type: userCard?.customerPropertySituation === 0 ? "Propriétaire" : userCard?.customerPropertySituation === 1 ? "Locataire" : "",
        type: userCard?.companyName && userCard.companyName.trim() !== "" ? "Professionnel" : "Particulier"
      };
    }

    this.pushToDataLayer(layerData);
  }

  /**
   * Tracking d’une interaction utilisateur (interaction event)
   */
  public trackInteraction(description: string, detail?: string, extra?: Record<string, any>) {
    let layerData: any = {
      event: 'interaction',
      event_id: this.generateEventId(),
      interaction: {
        description: description,
        ...(detail ? { detail } : {}),
        ...(extra ? extra : {})
      }
    };

    const userCard = this.userStore.userCard();
    if (userCard) {
      layerData.user = {
        card_type: userCard?.cardType === 2 ? "C-Casto" : userCard?.cardType === 3 ? "C-Casto Max" : "",
        home_type: userCard?.habitationType === 0 ? "Appartement" : userCard?.habitationType === 1 ? "Maison" : "",
        has_project: userCard?.projectNext6Months ? Object.values(userCard.projectNext6Months).some(v => v) ? "oui" : "non" : "non",
        id: userCard?.id ?? null,
        is_logged_in: true,
        loyalty_card_number: userCard?.cardNumber ?? null,
        project_type: userCard?.projectNext6Months ? Object.entries(userCard.projectNext6Months).filter(([_, value]) => value).map(([key]) => key) : [],
        status_type: userCard?.customerPropertySituation === 0 ? "Propriétaire" : userCard?.customerPropertySituation === 1 ? "Locataire" : "",
        type: userCard?.companyName && userCard.companyName.trim() !== "" ? "Professionnel" : "Particulier"
      };
    }

    this.pushToDataLayer(layerData);
  }

  /**
   * Log et push dans le datalayer
   */
  private pushToDataLayer(layerData: any) {
    if (this.trackLog) {
      console.log('#######  DATALAYER #######');
      console.table(layerData);
    }

    if (this.tracking) {
      this.ngZone.runOutsideAngular(() => this.dataLayer.push(layerData));
    }
  }

}
